<template>
  <div class="ui-tabs">
    <nav class="ui-tabs__wrapper" aria-label="Tabs" :class="wrapperClasses">
      <template v-for="tab in tabs" :key="tab.name">
        <router-link
          v-if="tab.route"
          :to="tab.route"
          :disabled
          exact
          exact-active-class="ui-tabs__item--active"
          class="ui-tabs__item"
        >
          {{ tab.name }}
        </router-link>
        <div
          v-else
          class="ui-tabs__item"
          :class="{
            'ui-tabs__item--active': modelValue === tab.name,
          }"
          @click="handleClick(tab.name)"
        >
          {{ tab.name }}
        </div>
      </template>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { TabsItem } from './utils/types'

type Props = {
  tabs: TabsItem[]
  disabled?: boolean
}

const props = defineProps<Props>()

const modelValue = defineModel<string>()

const wrapperClasses = computed(() => ({
  'ui-tabs__wrapper--disabled': props.disabled,
}))

const handleClick = (name: string) => {
  if (props.disabled) return
  modelValue.value = name
}
</script>

<style>
.ui-tabs {
  @apply w-full;
  @apply bg-body-dark;
  @apply rounded-lg;
  @apply overflow-x-auto;

  &__wrapper {
    @apply flex items-center gap-x-1;
    @apply p-1;

    &--disabled {
      @apply opacity-50;
      @apply cursor-not-allowed;
      @apply pointer-events-none;
    }
  }

  &__item {
    @apply flex-auto;
    @apply block;
    @apply p-2;
    @apply text-xs;
    @apply rounded-md;
    @apply hover:text-primary dark:hover:text-indigo-300;
    @apply font-medium uppercase;
    @apply text-center;
    @apply cursor-pointer;

    &--active {
      @apply !bg-white dark:!bg-body;
      @apply shadow-[0_0_0.25rem_rgba(0,0,0,0.05)];
      @apply !text-common-text;
    }
  }
}
</style>
